import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { EditorFeatureConfigSymbol, PageFeatureConfigSymbol, pageIdSym } from '@wix/thunderbolt-symbols'
import { ActiveVariantsApiSymbol, name as featureName } from '../symbols'
import {
	IActiveVariantsApi,
	ITriggersBreakpointValidator,
	TriggersAndReactionsEditorConfig,
	TriggersAndReactionsPageConfig,
} from '../types'
import { ReactionsInBpRange } from '@wix/thunderbolt-becky-types'
import { isTriggerBpRangeInCurrentWindowRange } from '../utils'

const nonSpecificPresetReactionsTypes = ['ScrollBackward', 'ScrollForward']

const triggersBreakpointValidatorFactory = (
	{ presetVariantsToReactionVariants }: TriggersAndReactionsPageConfig,
	{ isBlocksEditor }: TriggersAndReactionsEditorConfig,
	activeVariantsApi: IActiveVariantsApi,
	pageId: string
): ITriggersBreakpointValidator => {
	const isReactionInPreset = (reactionsInBpRange: ReactionsInBpRange) => {
		const activeVariant = activeVariantsApi.getActiveVariant(pageId)
		return (
			reactionsInBpRange.reactions.filter((reaction) => {
				const reactionId = reaction.reactionData.name
					? reaction.reactionData.name
					: reaction.reactionData.effect
				return (
					nonSpecificPresetReactionsTypes.includes(reaction.type) ||
					presetVariantsToReactionVariants[activeVariant].includes(reactionId)
				)
			}).length > 0
		)
	}

	return {
		isTriggerBpRangeInCurrentBreakpoint: (reactionsInBpRange: ReactionsInBpRange) => {
			if (isBlocksEditor) {
				return isReactionInPreset(reactionsInBpRange)
			}
			return isTriggerBpRangeInCurrentWindowRange(reactionsInBpRange.triggerBpRange)
		},
	}
}

export const triggersBreakpointValidator = withDependencies(
	[
		named(PageFeatureConfigSymbol, featureName),
		named(EditorFeatureConfigSymbol, featureName),
		ActiveVariantsApiSymbol,
		pageIdSym,
	],
	triggersBreakpointValidatorFactory
)
